module.exports = __webpack_public_path__ + "img/damage-riven.37944b4c.png";